import { contract, createTheme, gel2LightTheme } from '@snsw-gel/theming';
import { deepMerge } from 'grommet/utils';
import { PoliceFooterDivider, PoliceFooterLinkItem, PoliceFooterLinks } from 'app/components/themes/policeTheme.styled';
import CustomFooter from 'app/components/common/customFooter/CustomFooter';

export const policeColors = {
  POLICE_BLUE: '#002664',
  POLICE_BLUE_HOVER: '#2e5299',
};

// NOTE: these color names will likely need to be updated in future GEL versions
export const policeLightTheme = createTheme(contract, {
  name: 'gel2-police-light-theme',
  matches: [],
  type: 'light',
  colors: deepMerge(gel2LightTheme.config.colors, {
    primary: {
      default: policeColors.POLICE_BLUE,
      border: policeColors.POLICE_BLUE,
      hover: policeColors.POLICE_BLUE_HOVER,
      active: policeColors.POLICE_BLUE,
    },
    secondary: {
      default: 'transparent',
      border: policeColors.POLICE_BLUE,
      text: policeColors.POLICE_BLUE,
      hover: policeColors.POLICE_BLUE_HOVER,
      hoverText: 'white',
    },
  }),
});

type FooterLink = {
  text: string;
  url: string;
};

const FOOTER_LINKS: FooterLink[] = [
  { text: 'NSW Police Force', url: 'https://www.police.nsw.gov.au' },
  { text: 'Firearms Registry', url: 'https://www.police.nsw.gov.au/online_services/firearms' },
  { text: 'Privacy', url: 'https://www.police.nsw.gov.au/privacy' },
  { text: 'Accessibility', url: 'https://www.police.nsw.gov.au/accessibility' },
  { text: 'Contact us', url: 'https://www.police.nsw.gov.au/contact_us' },
];

export const PoliceGlobalNavFooter = (
  <>
    <CustomFooter>
      <p>
        The New South Wales Police Force acknowledge First Nations People as the Traditional Owners and custodians of
        all lands and water ways. We pay our respects to Elders past, present and emerging.
        <br /> <br />
        This booking service is operated by Service NSW on behalf of the NSW Police Force.
      </p>
      <PoliceFooterDivider />
      <PoliceFooterLinks>
        {FOOTER_LINKS.map((link) => (
          <PoliceFooterLinkItem key={link.url}>
            <a href={link.url} target="_blank" rel="noopener noreferrer">
              {link.text}
            </a>
          </PoliceFooterLinkItem>
        ))}
      </PoliceFooterLinks>
    </CustomFooter>
  </>
);
